import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { LoopBackAuth } from '../../Api/services/core';
import { NotificationService } from '../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { MapService } from '../services/map.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private auth: LoopBackAuth,
        private noticationService: NotificationService,
        private translate: TranslateService,
        private mapService: MapService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    this.auth.clear();
                    this.noticationService.create(this.translate.instant('auth.logOutByOtherDeviceLogin'));
                    this.mapService.clearAccount();
                    this.router.navigate(['login']);
                }
                return throwError(error);
            }));
    }
}
